import { render, staticRenderFns } from "./ThemeGroupbuyingDetail.vue?vue&type=template&id=0826e1f8&"
import script from "./ThemeGroupbuyingDetail.vue?vue&type=script&lang=js&"
export * from "./ThemeGroupbuyingDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports